// extracted by mini-css-extract-plugin
export var cardIcon = "_7r-4";
export var checkboxCard = "_7r-0";
export var checkboxCardSelected = "_7r-3";
export var disabled = "_7r-1";
export var outerBorder = "_7r-2";
export var spacerMedium = "_7r-7";
export var spacerSmall = "_7r-6";
export var spacerXsmall = "_7r-5";